<!-- Header Structure -->
<template>
    <div>
        <v-navigation-drawer
            id="nav_menu"
            v-if="!horizontal"
            app
            fixed
            :value="drawer"
            :mini-variant="collapseSidebar"
            mini-variant-width="70"
            :width="250"
            mobile-break-point="1300"
            class="Vuely-sidebar"
            :style="{ backgroundImage: 'url(' + selectedSidebarBgImage.url + ')' }"
            :class="{ 'background-none': !backgroundImage }"
            :right="rtlLayout"
        >
            <!-- App Sidebar -->
            <app-sidebar></app-sidebar>
        </v-navigation-drawer>
        <v-toolbar class="Vuely-toolbar" app color="primary" fixed>
            <!-- :color="activeHeaderFilter.class" -->
            <div class="d-custom-flex align-items-center navbar-left">
                <div v-if="!horizontal">
                    <v-toolbar-side-icon dark icon large @click.stop="toggleDrawer()"></v-toolbar-side-icon>
                    <span v-if="$bp.width > 320">{{ live_date_time }}</span>
                    <div v-if="dev_mode" class="unselectable ignore-hover d-inline-flex border ml-2 pa-2 red" color="white">
                        {{ $bp.smallScreen ? "DEV MODE" : $t("lang.development_mode") }}
                    </div>
                </div>
                <div class="site-logo-wrap d-custom-flex ml-0 align-items-center" v-else>
                    <router-link :to="{ name: 'dashboard' }" class="grayish-blue site-logo-img">
                        <img src="/static/img/site-logo.png" alt="site logo" height="35" />
                    </router-link>
                </div>
                <v-snackbar
                    v-if="checkLoggedInAsDiffUser"
                    v-model="snackbar"
                    :bottom="y === 'bottom'"
                    :left="x === 'left'"
                    :multi-line="mode === 'multi-line'"
                    :right="x === 'right'"
                    :timeout="timeout"
                    :top="y === 'top'"
                    :vertical="mode === 'vertical'"
                >
                    {{ `You're currently logged in as: ${loggedInUser != null ? loggedInUser.combined_name : ""}` }}
                    <v-btn color="primary" flat @click="switchBackMainUser()"> Switch </v-btn>
                </v-snackbar>
            </div>
            <div class="navbar-right">
                <header-notifications @closeProfile="$refs.userProfile.closeProfile = false" ref="headerNotifs"></header-notifications>
                <!-- <scan-qr-code></scan-qr-code> -->
                <!-- <v-btn class="ma-0" dark icon large @mouseup.left.stop="openArticlesMenu()">
					<v-icon>help_center</v-icon>
				</v-btn> -->
                <user ref="userProfile" @closeNotifs="$refs.headerNotifs.closeMenu = false"></user>
            </div>
        </v-toolbar>
        <!-- Chat Searchbar -->
        <v-navigation-drawer
            v-click-overlay="overlayClicked"
            style="max-height: 100vh"
            id="help_article_menu"
            app
            fixed
            stateless
            :value="helpArticleMenu"
            :temporary="!$bp.lgAndUp"
            :right="!rtlLayout"
            class="chat-sidebar-wrap"
        >
            <chat-sidebar
                ref="chatSidebar"
                :updateSearch="updateSearch"
                :searchInput="searchInput"
                :route="currentRoute"
                :chatSidebar="helpArticleMenu"
                :getArticles="getArticles"
                @update="$store.commit('toggleHelpArticleMenuHandler')"
            ></chat-sidebar>
        </v-navigation-drawer>
        <mobile-search-form></mobile-search-form>
    </div>
</template>

<script>
import Sidebar from "../Sidebar/Sidebar.vue";
import ChatSidebar from "../ChatSidebar/ChatSidebar.vue";
import HeaderNotifications from "./HeaderNotifications";
import User from "./User";
import MobileSearchForm from "./MobileSearchForm";
import ScanQrCode from "./ScanQrCode";

import { mapGetters } from "vuex";

export default {
    props: {
        horizontal: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            collapsed: false, // collapse sidebar
            chatSidebar: false, // chat component right sidebar
            sidebarImages: "", // sidebar background images
            enableDefaultSidebar: false,
            fav: true,
            menu: false,
            message: false,
            hints: true,
            currentRoute: null,
            searchInput: "",
            live_date_time: "",
            snackbar: false,
            y: "top",
            x: null,
            mode: "",
            timeout: 0,
            text: "Hello, I'm a snackbar",
            loggedInUser: null,
        };
    },
    computed: {
        ...mapGetters([
            "rtlLayout",
            "backgroundImage",
            "backgroundImage",
            "selectedSidebarBgImage",
            "darkMode",
            "collapseSidebar",
            "activeHeaderFilter",
            "helpArticleMenu",
            "drawer",
            "help_articles",
        ]),
        axiosParams() {
            const params = new URLSearchParams();
            if (this.searchInput != "") {
                params.append("search", this.searchInput);
            } else {
                params.append("module", this.currentRoute);
            }
            params.append("language", this.current_user.language);
            return params;
        },
        checkLoggedInAsDiffUser() {
            return localStorage.getItem("original_current_user") === null ? false : true;
        },
    },
    mounted() {
        this.setRoute(this.$route.path);
        this.checkDrawerStatus();
        this.setInitialTime();
        if (localStorage.getItem("original_current_user") !== null && this.$bp.mdAndUp) {
            this.loggedInUser = JSON.parse(localStorage.getItem("current_user"));
            this.snackbar = true;
        }
    },
    watch: {
        //grab current base route
        $route: {
            handler(to, from) {
                this.setRoute(to.path); //TODO: should be passing path name
                if (this.helpArticleMenu && this.searchInput == "") {
                    this.getArticles();
                }
            },
        },
        drawer() {
            this.checkDrawerStatus();
        },
        helpArticleMenu() {
            this.checkDrawerStatus();
        },
        "$bp.lgAndUp": function (newVal, oldVal) {
            if (newVal) {
                this.checkDrawerStatus();
            }
        },
    },
    methods: {
        setInitialTime() {
            let seconds_to_next =
                60 -
                new Date().toLocaleString("en-US", { timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York", second: "2-digit" });
            this.getCurrentTime();
            setTimeout(() => {
                this.getCurrentTime();
                setInterval(this.getCurrentTime, 60000);
            }, Math.max(seconds_to_next, 0) * 1000);
        },
        getCurrentTime() {
            this.live_date_time = new Date().toLocaleString("en-US", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour12: false,
                hour: "numeric",
                minute: "numeric",
            });
        },
        overlayClicked() {
            this.$store.commit("toggleMainMenu", false);
            this.$store.commit("toggleHelpArticleMenuHandler", false);
        },
        setRoute(route) {
            //TODO: should set routes from names
            let path = route.slice(1);
            if (path.indexOf("/") == -1) {
                this.currentRoute = path;
            } else {
                this.currentRoute = path.slice(0, path.indexOf("/"));
            }
        },
        checkDrawerStatus() {
            //check drawer and help article menu to add click event to overlay to remove it if clicked on
            if (this.drawer || this.helpArticleMenu) {
                if (this.drawer && this.helpArticleMenu) {
                    // stateless helpArticleMenu means on resize let mainMenu stay open since thats automatic
                    this.$store.commit("toggleHelpArticleMenuHandler", false);
                }
                this.$nextTick(() => {
                    $(".v-overlay").click(() => {
                        this.$store.commit("toggleMainMenu", false);
                        this.$store.commit("toggleHelpArticleMenuHandler", false);
                    });
                });
            }
        },
        updateSearch(search) {
            if (!search) {
                this.searchInput = "";
            } else {
                this.searchInput = search;
            }
        },
        logoutUser() {
            this.$store.dispatch("logoutUser", this.$router);
        },
        getArticles() {
            this.$store.commit("toggleSidebarLoader", true);
            this.$store
                .dispatch("fetchHelp", {
                    url: "help",
                    method: "get",
                    stateProperty: "help_articles",
                    commit: true,
                    body: this.axiosParams,
                })
                .then((data) => {
                    this.$store.commit("toggleSidebarLoader", false);
                });
        },
        toggleDrawer() {
            this.$refs.userProfile.closeProfile = false;
            this.$refs.headerNotifs.closeMenu = false;
            this.$store.commit("toggleMainMenu");
            if (this.helpArticleMenu) this.$store.commit("toggleHelpArticleMenuHandler", false);
        },
        openArticlesMenu() {
            this.$refs.userProfile.closeProfile = false;
            this.$refs.headerNotifs.closeMenu = false;
            this.$store.commit("toggleHelpArticleMenuHandler");
            if (this.helpArticleMenu && this.searchInput == "") this.getArticles();
            if (this.drawer) this.$store.commit("toggleMainMenu", false);
        },
        // examples of how to start tours
        runNav() {
            this.$store.commit("toggleMainMenu", false);
            this.$store.commit("changeTour", "nav");
            this.$tours["currentTour"].stop();
            this.$tours["currentTour"].start();
        },
        runPeople() {
            this.$store.commit("toggleMainMenu", false);
            this.$store.commit("changeTour", "people");
            this.$tours["currentTour"].stop();
            this.$tours["currentTour"].start();
        },
        switchBackMainUser() {
            let drawer = localStorage.getItem("original_drawer");
            let dashboard_original_layout = localStorage.getItem("original_dashboard_original_layout");
            let dashboard_layout = localStorage.getItem("original_dashboard_layout");
            let token = $cookies.get("original_token");
            let current_user = localStorage.getItem("original_current_user");

            localStorage.setItem("drawer", drawer);
            localStorage.setItem("dashboard_original_layout", dashboard_original_layout);
            localStorage.setItem("dashboard_layout", dashboard_layout);
            $cookies.set("token", token, null, null, null, true, "Strict");
            localStorage.setItem("current_user", current_user);

            localStorage.removeItem("original_drawer");
            localStorage.removeItem("original_dashboard_original_layout");
            localStorage.removeItem("original_dashboard_layout");
            $cookies.remove("original_token");
            localStorage.removeItem("original_current_user");
            location.reload();
        },
    },
    components: {
        appSidebar: Sidebar,
        ChatSidebar,
        HeaderNotifications,
        MobileSearchForm,
        User,
        ScanQrCode,
    },
};
</script>
